import {TransferConstants} from "finhelper";

export const getSpendingTypes = (actionTypeId) =>
{
    let types = [
        {id: TransferConstants.BETWEEN_ACCOUNTS, name: 'Перевод между счетами'},
        {id: TransferConstants.TAX, name: 'Уплата налога'},
        {id: TransferConstants.COMMISSION, name: 'Комиссия'},
        {id: TransferConstants.SPENDING, name: 'Расход'},
        {id: TransferConstants.CHANGE, name: 'Перевод на другой счет с конвертацией'},//CONVERTATION
        {id: TransferConstants.BETWEEN_ACCOUNTS_TEMP, name: 'Перевод между счетами'},
        {id: TransferConstants.BUY_OWN_ACTIVE, name: 'Покупка личного актива'},
        {id: TransferConstants.BUY_INVEST_ACTIVE, name: 'Покупка инвестиционного актива'},
        {id: TransferConstants.ADD_OWN_ACTIVE, name: 'Привязка к личному активу'},
        {id: TransferConstants.ADD_INVEST_ACTIVE, name: 'Привязка к инвестиционному активу'},
        // {id: TransferConstants.ADD_PAYMENT, name: 'Привязка платежа к активу'},
        {id: TransferConstants.ADD_OBLIGATION_PAYMENT, name: 'Привязка платежа к обязательству'},
        {id: TransferConstants.CONNECT_PAYMENT, name: 'Привязка платежа к доходу'},
    ];
    //если выбран перевод между счеатми где участвует временный счет, то скрываем обычный перевод между счетами
    //в противном случае скрываем перевод между временными счетами, такие операция удаляются при пересчете
    //и создавать их нельзя
    if (typeof actionTypeId === TransferConstants.BETWEEN_ACCOUNTS_TEMP) {
        types = types.filter((item) => {
            return item.id !== TransferConstants.BETWEEN_ACCOUNTS;
        })
    } else {
        types = types.filter((item) => {
            return item.id !== TransferConstants.BETWEEN_ACCOUNTS_TEMP;
        })
    }

    return types;
}